import { render, staticRenderFns } from "./importdata-collector-to-debitur.vue?vue&type=template&id=acf83ccc&scoped=true&"
import script from "./importdata-collector-to-debitur.vue?vue&type=script&lang=js&"
export * from "./importdata-collector-to-debitur.vue?vue&type=script&lang=js&"
import style0 from "./importdata-collector-to-debitur.vue?vue&type=style&index=0&id=acf83ccc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf83ccc",
  null
  
)

export default component.exports